import { render, staticRenderFns } from "./BoClientsLogo.vue?vue&type=template&id=00bcfc70&"
import script from "./BoClientsLogo.vue?vue&type=script&lang=js&"
export * from "./BoClientsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports